import React from "react";
import { assets } from "../assets/assets";

const OurPolicy = () => {
  return (
    <>
      <div className="flex flex-row flex-wrap justify-around items-center gap-4 sm:gap-3 text-center py-6 text-[10px] sm:text-xs md:text-sm text-gray-700">
        {/* Easy Exchange */}
        <div className="w-auto">
          <img
            src={assets.exchange_icon}
            className="w-6 sm:w-8 m-auto mb-2"
            alt="Easy Exchange"
          />
          <p className="font-semibold text-[10px] sm:text-xs">Easy Exchange</p>
          <p className="text-gray-400 text-[8px] sm:text-[10px]">
            Hassle-free exchange
          </p>
        </div>

        {/* 7 Days Return */}
        <div className="w-auto">
          <img
            src={assets.quality_icon}
            className="w-6 sm:w-8 m-auto mb-2"
            alt="7 Days Return"
          />
          <p className="font-semibold text-[10px] sm:text-xs">7 Days Return</p>
          <p className="text-gray-400 text-[8px] sm:text-[10px]">
            Free returns within 7 days
          </p>
        </div>

        {/* 24/7 Support */}
        <div className="w-auto">
          <img
            src={assets.support_img}
            className="w-6 sm:w-8 m-auto mb-2"
            alt="24/7 Support"
          />
          <p className="font-semibold text-[10px] sm:text-xs">24/7 Support</p>
          <p className="text-gray-400 text-[8px] sm:text-[10px]">
            We are here for you anytime
          </p>
        </div>
      </div>
    </>
  );
};

export default OurPolicy;
